import { type FC, type PropsWithChildren, useEffect } from 'react';
import { useLocation } from 'react-router';
import { useWatchPayinOrdersCount } from '~/features/payin';
import { useWatchPayoutOrdersCount } from '~/features/payout';
import { getProcessingModeByPathname, setProcessingMode } from '~/entities/processing-mode';

type WatchersProviderProps = PropsWithChildren;

export const WatchersProvider: FC<WatchersProviderProps> = ({ children }) => {
    const { pathname } = useLocation();

    useWatchPayinOrdersCount();
    useWatchPayoutOrdersCount();

    useEffect(() => {
        const mode = getProcessingModeByPathname(pathname);

        if (mode) {
            setProcessingMode(mode);
        }
    }, [pathname]);

    return children;
};
